import React from 'react';

interface IAddIconProps {
  style?: any;
}

const RemoveIconWhite:React.FC<IAddIconProps> = (props: IAddIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" fill="none" viewBox="0 0 16 15" style={props.style}>
        <path fill="#F5F5F5" fillRule="evenodd" d="M7.086 8.136l-3 2.928.913.89L8.129 8.9l3.13 3.055.914-.891-3-2.928 3-2.927-.913-.89-3.13 3.054-3.131-3.055-.913.891 3 2.927z" clipRule="evenodd"/>
    </svg>
  )
}

export default RemoveIconWhite;